
































import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { Page } from '@getaccept/dsr-shared/src/types/page';
import { SidebarPlacement } from '@getaccept/dsr-shared/src/types/sidebar-placement';
import SidebarInnerWrapper from '@getaccept/dsr-shared/src/components/SidebarInnerWrapper.vue';
import PoweredByLogo from './../../assets/powered-by-ga.svg';
import PageListItem from './PageListItem.vue';

export default defineComponent({
  name: 'PageNavigationBar',
  components: {
    SidebarInnerWrapper,
    PageListItem,
    PoweredByLogo,
  },
  props: {
    pages: {
      default: () => [],
      type: Array as PropType<Page[]>,
    },
    currentPageId: {
      type: String,
      default: null,
    },
  },
  setup() {
    const handlePoweredByClick = () => window.open('https://www.getaccept.com', '_blank');

    return { SidebarPlacement, handlePoweredByClick, PoweredByLogo };
  },
});
